import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Redirect } from 'react-router-dom'
import "@pathofdev/react-tag-input/build/index.css";
import { setCookie, getCookie } from '../common_component/cookie.js';
import { useAuthData } from "./auth-provider.js";
import PageError from '../common_component/PageError.js';

export const ShowRoles = () => {
    const [state, setstate] = useState(2);
    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false)
    const [editmodal, setEditModal] = useState([]);

    var page_name = "roles";

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    useEffect(() => {
        async function getpolicydetails() {
            var object = {};
            object.email = user.email;

            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-roles`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id, "service": process.env.REACT_APP_module_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            setEditModal(body);
            if (body.length > 0) {
                setstate(1);
            }
            else {
                setstate(0);
            }
        }
        if ((read || write) && organization_id !== "") {
            user.email && visibility && getpolicydetails();
        }

    }, [user, visibility, read, write, organization_id])


    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Show Roles</h1>
                </div>
                <div>
                    {state === 1 ?
                        <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-5 g-xl-9">
                            {editmodal.length > 0 && editmodal.map((obj, index) => {
                                return (
                                    <>
                                        <div className="col-md-4">
                                            <div className="card card-flush h-md-100">
                                                <div className="card-header">
                                                    <div className="card-title">
                                                        <h2>{obj.user_role}</h2>
                                                    </div>
                                                    <div className="card-toolbar">
                                                        <div className="dropdown">
                                                            {
                                                                (write) ?
                                                                    <>
                                                                        <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"><i className="fas fa-bars px-0"></i></button>
                                                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                            {obj.default !== "true" && <li className="py-1"><a href={`update-roles/${obj.user_role_id}`} className="dropdown-item">Edit Details</a></li>}
                                                                        </ul>
                                                                    </>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="card-body pt-1">
                                                    <div className="fw-bold text-gray-600 mb-5">Total users with this role: {obj.user_count}</div>
                                                    <div className="d-flex flex-column text-gray-600">
                                                        {obj.role_description !== "" &&
                                                            <div className='d-flex align-items-center py-2'>
                                                                <span className='bullet bg-primary me-3'></span>
                                                                <em>{obj.role_description}</em>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            })}
                        </div>
                        :
                        state === 2 ?
                            <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                            :
                            <PageError />
                    }
                </div>
            </div>
        </>);

};

export default ShowRoles;
